
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/service_marketbom",
      function () {
        return require("private-next-pages/service_marketbom/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/service_marketbom"])
      });
    }
  